import React from "react";
import { Table, Row, Col } from "antd";
import "./Fcmt.style.css";
import logoImage from "../../src/Images/thermologo.png";
import ttLogo from "../../src/Images/TT_original.png"
import Plot from "react-plotly.js";

const PDFMakerFCMT = React.forwardRef((props, ref) => {
  const {
    columns,
    resultData,
    inputtable,
    Customer_name,
    Comments,
    datasource1,
    columns1,
    engineRunLayout,
    engineRunData,
    tempLayout,
    tempData,
    includeEmission
  } = props;

  const data = Object.entries(inputtable).map(([key, value], index) => ({
    key: index,
    columnKey: key,
    columnValue: value,
  }));
  const getUserInfo = localStorage.getItem("ecotrip_user");
  const userDetail = JSON.parse(getUserInfo)?.idTokenClaims;

  const tableClass = includeEmission =="Yes" ? 'my-tableEmission' : 'my-table';
  const tableClassForAPP = includeEmission =="Yes" ? 'my-tableEmission appDatatable' : 'my-table';

  const UserInpTable = () => {
    return (
      <Table
        dataSource={datasource1}
        columns={columns1}
        pagination={false}
        bordered
        className={tableClassForAPP}
        title={() => <span style={{ fontWeight: "bold" }}>Application</span>}
        style={{ textAlign: "center" }}
        size="small"
      />
    );
  }

  const UserInfoTable = () => {
    const dataSource = [
      {
        key: "1",
        title: "Created By",
        value: userDetail?.FirstName + " " + userDetail?.LastName,
      },
      {
        key: "1",
        title: "Date",
        value: new Date().toLocaleString(),
      },
      {
        key: "1",
        title: "Customer",
        value: Customer_name,
      },
    ];

    const columns = [
      {
        title: "Title",
        dataIndex: "title",
        key: "title",
      },
      {
        title: "Value",
        dataIndex: "value",
        key: "value",
      },
    ];
    return (
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        bordered
        className={tableClass}
        title={() => (
          <span style={{ fontWeight: "bold" }}>User Information</span>
        )}
        style={{ textAlign: "center", width: "500px",textWrapMode: "nowrap" }}
        size="small"
      />
    );
  };

  return (
    <div ref={ref}>
      <div className="img-logo"
      >
        <img
          src={logoImage}
          alt="Thermoking Logo"
          style={{
            width: "5.9cm",
            height: "1cm",
            padding: '  25px 5px 30px 30px'
          }}
        />
        <img
          src={ttLogo}
          alt="Trane Technologies Logo"
          style={{
            width: "1.77 cm",
            height: "1cm",
            padding: ' 25px 35px 30px 30px'
          }}
        />
      </div>
      <div className="content-section1">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            //justifyContent: "space-between",
            gap: '22px',
            padding: "5px 0px 0px 30px",
          }}
        >
          <div
            style={{
              pageBreakInside: "avoid",
            }}
          >
            <UserInfoTable />
          </div>
          <div
            className="content-section "
            style={{ pageBreakInside: "avoid" }}
          >
            <Table
              dataSource={resultData}
              columns={columns}
              pagination={false}
              className={tableClass}
              title={() => <span style={{ fontWeight: "bold" }}>Results</span>}
              style={{ textAlign: "center", width: "500px" }}
              size="small"
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              backgroundColor: "white",
              border: "2px solid black",
              overflowWrap: "break-word",
              padding: "5px",
              width: "488px",
              height: "100px"
            }}
          >
            <span style={{ fontWeight: "bold", fontSize: "1rem" }}>
              Comments:
            </span>
            <span style={{ fontSize: "0.8rem" }}>{Comments}</span>
          </div>
        </div>
        <div
          className="content-section "
          style={{ pageBreakInside: "avoid", padding: "5px 30px 0px 10px ", height: '670px' }}
        >
          <UserInpTable />
        </div>
      </div>
      <div
        style={{ display: "flex", flexDirection: "column", marginTop: "10px" }}
      >
        <span
          style={{
            fontWeight: "bold",
            textAlign: "center",
            padding: '15px 0px 0px 0px'
          }}
        >
          Result plots
        </span>
        <div
          className="content-section img"
          style={{
            display: "flex",
            justifyContent: "center",

            padding: '0px 30px 0px 30px'
          }}
        >
          <Row span={24}>
            <Col span={23} className="">
              <Plot
                data={tempData}
                layout={tempLayout}
                style={{ width: "13cm", height: '10cm' }}
              />
              <div id="graph" style={{ display: "none" }}></div>
            </Col>
          </Row>
          <Row span={24}>
            <Col span={23} className="">
              <Plot
                data={engineRunData}
                layout={engineRunLayout}
                style={{ width: "13cm", height: '10cm' }}
              />
              <div id="graph1" style={{ display: "none" }}></div>
            </Col>
          </Row>
        
        </div>
        <Row span={24}>
            <Col span={23} className="">
            <div className="version" style={{    textAlign: "right", fontSize: "0.5rem",padding:" 0 5px"}}>Version: {process.env.REACT_APP_VERSION}</div>
            </Col>
          </Row>
      </div>
    </div>
  );
});

export default PDFMakerFCMT;
